// extracted by mini-css-extract-plugin
export default {"CopyText":"CopyText_CopyText__vrOZe","CopyText__logo":"CopyText_CopyText__logo__ryZPu"};